// Angular
import { Injectable } from "@angular/core";
import {
	HttpEvent,
	HttpInterceptor,
	HttpHandler,
	HttpRequest,
	HttpResponse,
} from "@angular/common/http";
// RxJS
import { Observable } from "rxjs";
import { tap, finalize } from "rxjs/operators";
import { Router } from "@angular/router";
import { environment } from "@app/../environments/environment";
import { RootSpinnerService } from "@app/services/root-spinner.service";
import { Store } from "@ngrx/store";
import { AppState } from "@app/core/reducers";
import { Logout } from "@app/core/auth/_actions/auth.actions";
//import { debug } from 'util';

/**
 * More information there => https://medium.com/@MetonymyQT/angular-http-interceptors-what-are-they-and-how-to-use-them-52e060321088
 */
@Injectable()
export class InterceptService implements HttpInterceptor {
	constructor(private router: Router, private store: Store<AppState>) {}

	// intercept request and add token
	intercept(
		request: HttpRequest<any>,
		next: HttpHandler
	): Observable<HttpEvent<any>> {
		const token = localStorage.getItem(environment.authTokenKey);
		
		// Thêm headers: Authorization + chống cache
		// Cache-Control: no-cache bắt buộc để trình duyệt không dùng cached response
		// Khi không mở DevTools, trình duyệt có thể cache response API (kể cả 401)
		// → sau login + reload, getMyInfo trả cached 401 cũ thay vì gọi mới với token mới
		if (token) {
			request = request.clone({
				setHeaders: {
					Authorization: `Bearer ${token}`,
					'Cache-Control': 'no-cache',
					'Pragma': 'no-cache',
				},
			});
		} else {
			request = request.clone({
				setHeaders: {
					'Cache-Control': 'no-cache',
					'Pragma': 'no-cache',
				},
			});
		}

		//  console.log('----request----');
		//  console.log(request);
		//  console.log('--- end of request---');
		if (request.method != "GET") {
			RootSpinnerService.show();
		}
		return next.handle(request).pipe(
			tap(
				(event) => {
					if (event instanceof HttpResponse) {
						// console.log('all looks good');
						// http response status code
						// console.log(event.status);
					}
				},
				(error) => {
					// http response status code
					//console.log('----response------------------------------');
					//console.error('status code:');
					// tslint:disable-next-line:no-debugger
					//Redirect to login when invalid token
					if (error.status == 401) {
						RootSpinnerService.hide();
						// KHÔNG xóa token và KHÔNG dispatch Logout ở đây.
						// Interceptor chỉ là middleware - không nên quyết định auth state.
						// Việc xử lý token hết hạn do loadUser$ effect đảm nhận
						// (khi API getMyInfo trả 401 → xóa token + logout).
						// Các API khác trả 401 chỉ đơn giản là bị bỏ qua.
						console.warn('[INTERCEPTOR] 401 from:', request.url);
					}
					// else if(error.status==404){
					// 	if(!this.router.url.includes("returnUrl") && this.router.url.includes("document")){
					// 		console.log("this.router",this.router.url);
					// 		this.router.navigate(['/'],{queryParams: {returnUrl: this.router.url}});
					// 	}
					// }
					//console.log('--- end of response---');
				}
			),
			finalize(() => {
				if (request.method != "GET") {
					RootSpinnerService.hide();
				}
			})
		);
	}
}
